export default function createTodoRef(db, subjectId, type) {
	return db.collection("todos").doc(`${subjectId}-${type}`);
}
